import {
    Box,
    VStack,
    FormErrorMessage,
    InputRightElement,
} from '@chakra-ui/react';
import { InputGroup } from '@/components/v4';
import { SingleDatepicker } from 'chakra-dayzed-datepicker';
import { chakraDatepicker, chakraDatepickerDarkMode } from '@/constants';
import { CalendarIcon } from '@chakra-ui/icons';
import {
    ChakraDatePickerDarkModeStyles,
    ChakraDatePickerStyles,
    getDayofMonthBtnProps,
    disabledSelectedDateStyle,
} from '@/chakratheme';
import { borderColor } from '../formStyles';

const DatePicker = ({ field, form: { errors }, ...props }) => {
    const getDayofMonthProps = getDayofMonthBtnProps(props?.darkMode);
    const baseDatePickerStyles = props?.darkMode
        ? ChakraDatePickerDarkModeStyles
        : ChakraDatePickerStyles;
    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'flex-start',
                paddingTop: '15px',
            }}>
            <VStack width="100%" alignItems="normal">
                <InputGroup
                    sx={
                        props.darkMode
                            ? chakraDatepickerDarkMode
                            : chakraDatepicker
                    }
                    data-walkthroughid={props.walkthroughid}>
                    <SingleDatepicker
                        {...field}
                        {...props}
                        disabled={props.isLoading}
                        minDate={new Date()}
                        name="date-input"
                        date={props.date ?? undefined}
                        onDateChange={(value) => {
                            props.changeHandler(
                                props.valueHandler,
                                value || 'expirationDate',
                                value,
                            );
                        }}
                        configs={{
                            dateFormat:
                                props.dateFormat || 'ccc, dd MMM, yyyy zzz',
                        }}
                        usePortal
                        propsConfigs={{
                            ...baseDatePickerStyles,
                            dayOfMonthBtnProps: {
                                ...baseDatePickerStyles.dayOfMonthBtnProps,
                                ...getDayofMonthProps,
                            },
                            dateNavBtnProps: {
                                border: 'none',
                                _focus: {
                                    border: 'none',
                                },
                            },
                            inputProps: {
                                height: '30px',
                                borderColor: props.darkMode
                                    ? borderColor
                                    : 'gray.200',
                            },
                            popoverCompProps: {
                                popoverContentProps: {
                                    background: props?.darkMode
                                        ? 'dark.bgDark'
                                        : 'white',
                                    border: props.darkMode
                                        ? borderColor
                                        : 'gray.200',
                                    boxShadow: 'var(--chakra-shadows-base)',
                                    sx: disabledSelectedDateStyle,
                                },
                            },
                            calendarPanelProps: {
                                contentProps: {
                                    borderWidth: 0,
                                },
                            },
                        }}
                    />
                    <InputRightElement
                        height="30px"
                        zIndex={0}
                        color={props.darkMode ? 'white' : 'gray.500'}
                        pointerEvents="none">
                        <CalendarIcon />
                    </InputRightElement>
                </InputGroup>
                <FormErrorMessage
                    display="flex"
                    sx={{ marginTop: '0 !important', fontSize: '10px' }}
                    justifyContent="flex-end">
                    {errors[field.name]}
                </FormErrorMessage>
            </VStack>
        </Box>
    );
};
export default DatePicker;
